import firebase from 'firebase/app'
import "firebase/storage"

var firebaseConfig = {
    apiKey: "AIzaSyB4YSMHSTistkg1B8qPXl7ULcwS8YRX7Ro",
    authDomain: "tvinsure-register-app.firebaseapp.com",
    databaseURL: "https://tvinsure-register-app.firebaseio.com",
    projectId: "tvinsure-register-app",
    storageBucket: "tvinsure-register-app.appspot.com",
    messagingSenderId: "524433908177",
    appId: "1:524433908177:web:7d2e8664daf12850df00f0"
};

firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();

export {storage, firebase as default}